import { deleteBlockURL, getAllBlocksURL, getBlocksWithPaginationURL } from "@app/constants/ApiEndPoints";
import axios from "axios";

export const getBlocksWithPagination = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(getBlocksWithPaginationURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}
															&name=${search.name}&subjectId=${search.subjectId}&moduleId=${search.moduleId}&description=${search.description}&status=${search.status}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllBlocks = async () => {
	try {
		const response = await axios.get(getAllBlocksURL);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteBlockById = async (id: number) => {
	try {
		const response = await axios.delete(deleteBlockURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data;
		}
		return response?.data;
	} catch (error) {
		return error?.response?.data;
	}
};